export enum notificationsListActions {
    SET_ACTIVE_TAB = 'SET_ACTIVE_TAB',
    SET_TABLE_STATE = 'SET_TABLE_STATE',
    SET_DRAWER = 'SET_DRAWER',
    SEARCH_NOTIFICATONS = 'SEARCH_NOTIFICATONS',
    RESET_NOTIFICATIONS_LIST_PAGE = 'RESET_NOTIFICATIONS_LIST_PAGE',
    SET_ALL_NOTIFICATIONS_VIEW = 'SET_ALL_NOTIFICATIONS_VIEW'
}
